import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux';
import { selectTheme } from './selectors'

const mapStateToProps = (state) => ({
  theme: selectTheme(state)
});

const withStoreTheme = () => compose(
  connect(mapStateToProps)
)

export default withStoreTheme


// WEBPACK FOOTER //
// ./src/store/theme/withStoreTheme.js